import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { shareOrderWithPatient } from 'api/Orders';

import { showAlert } from 'components/shared/Alert/Alert';

const useShareWithPatient = ({ patientId, unshare }) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const handleShareWithPatient = async ({ type, id }) => {
    const { success, email } = await shareOrderWithPatient(navigate, {
      patientId,
      type,
      id,
      ...(unshare ? { unshare } : {})
    });

    const message = success
      ? `Order ${unshare ? 'un' : ''}shared with patient successfully${!email && !unshare ? ', but the email failed' : ''}.`
      : `There was a problem  ${unshare ? 'un' : ''}sharing the order with the patient.`;

    const color = success ? 'success' : 'danger';

    showAlert({ message, color });

    queryClient.setQueriesData(['orders'], (old) => {
      return {
        ...old,
        data: old?.data?.map((item) => {
          if (item?.id === id) {
            return {
              ...item,
              myportal: !unshare
            };
          } else {
            return item;
          }
        })
      };
    });

    if (success) setShowConfirm(false);
  };

  const { mutate, isLoading } = useMutation(handleShareWithPatient);

  return {
    shareLoading: isLoading,
    showConfirm,
    share: mutate,
    setShowConfirm
  };
};

export default useShareWithPatient;
